import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/burnett.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>S&#228;mtliche schriften und briefe series I, volume 20</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 816-817<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 27 February 1702<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (64k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Thomas Burnett (27 February 1702)</title>
            <meta name="description" content="An English translation of a LETTER TO THOMAS BURNETT by Gottfried Wilhelm Leibniz, from 27 February 1702" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO THOMAS BURNETT</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A I 20, p816</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;...I would like all the books in favour of religion to resemble those by Mr Grew and Mr Ray, who show the wisdom of God in nature.<a name="1" href="#note1"><sup>1</sup></a> I put in an order that they be sent to me on the basis of the description that you gave me of them. But the books that go into detail on physics or mathematics are not those which Madam the Electress likes to read. The monotype book of your friend, <var>de statu animarum post mortem</var><a name="2" href="#note2"><sup>2</sup></a> will apparently support Origen's opinion on the ultimate salvation of all intelligent creatures.<a name="3" href="#note3"><sup>3</sup></a> We had some years ago a superintendent in L&#252;neburg, called Mr Petersen, a very learned man who left his charge because he very much wanted to dogmatize on Chiliasm.<a name="4" href="#note4"><sup>4</sup></a> Having continued his meditations into his retirement, he came to the same opinion, and published, two years ago or thereabouts, a book in German, in folio, entitled &#945;&#960;&#959;&#967;&#945;&#964;&#945;&#959;&#964;&#945;&#959;&#953;&#962; &#960;&#945;&#957;&#964;&#969;&#957;, or <var>On the Restitution of All Things</var>.<a name="5" href="#note5"><sup>5</sup></a> This book is written with a lot of erudition and judgement. The author collects all the passages from the ancients and moderns favourable to this doctrine, and he supports his opinion against learned adversaries with much moderation and diligence. I glanced through it with pleasure, and although I did not follow it carefully I did not fail to recognize its merit. He claims that the half-good will suffer during the reign of a thousand years until the day of judgement, [<b>A I 20, p817</b>] that then they (or rather just some of them, according to the degree of their corruption) will be admitted into the reign of Jesus Christ; and the wicked who have not been corrected during this interval will be thrown in with the demons in order to finish being corrected. This is the second death. But finally death will itself die, even the devil will change his mind and will be received into grace with all his angels and all the damned. And then, according to St. Paul, God will be all in all.<a name="6" href="#note6"><sup>6</sup></a> There are some pleasant ideas, to which only metempsychosis is lacking, or at least the pre-existence of souls, to complete Origenism. I know someone who imagines that this Lucifer, fallen and driven out of heaven, is the globe of the Earth, and although he was the globe of the sun or a fixed star, he became a planet, wandering and opaque, but that, in the restitution of all things, he will again become the sun, and the creatures that he supports will finish to be perfected at the same time...
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> John Ray, <var>The Wisdom of God</var> (London, 1691); Nehemiah Grew, <var>Cosmologia Sacra</var> (London, 1701).<br />
                <a name="note2" href="#2">2.</a> <var>On the State of Souls after Death</var>.<br />
                <a name="note3" href="#3">3.</a> Thomas Burnet, <var>De statu mortuorum et resurgentium</var> (London, 1720). English translation: Thomas Burnet, <var>A treatise concerning the state of departed souls before, and at, and after the resurrection</var> (London, 1730).<br />
                <a name="note4" href="#4">4.</a> Johann Wilhelm Petersen (1649-1727). He was dismissed from his post as superintendent of the churches of L&#252;neburg on 21 January 1692 on the grounds that he had defended his millenarian (chiliast) views in print after being warned by the ecclesiastical authorities not to teach such doctrines in public.<br />
                <a name="note5" href="#5">5.</a> Johann Wilhelm Petersen, &#924;&#965;&#963;&#964;&#951;&#961;&#953;&#959;&#965; &#945;&#960;&#959;&#967;&#945;&#964;&#945;&#959;&#964;&#945;&#959;&#953;&#962; &#960;&#945;&#957;&#964;&#969;&#957; [Mystery of the Restitution of All Things] (Offenbach, 1700). Subsequent volumes were published in 1703 and 1710.<br />
                <a name="note6" href="#6">6.</a> 1 Corinthians 15.28: 'And when all things shall be subdued unto him, then shall the Son also himself be subject unto him that put all things under him, that God may be all in all'.<br /><br /><br />
                &#169; Lloyd Strickland 2005<br />
                With thanks to Geert de Wilde
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
